import React from 'react';
import { Input, Button, Checkbox } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

interface QueryParamsProps {
  materialFrom: string;
  materialTo: string;
  fabricFrom: string;
  fabricTo: string;
  check1: boolean;
  check2: boolean;
  loading: boolean;
  onMaterialFromChange: (v: string) => void;
  onMaterialToChange: (v: string) => void;
  onFabricFromChange: (v: string) => void;
  onFabricToChange: (v: string) => void;
  onCheck1Change: (v: boolean) => void;
  onCheck2Change: (v: boolean) => void;
  onQuery: () => void;
}

const QueryParams: React.FC<QueryParamsProps> = ({
  materialFrom, materialTo, fabricFrom, fabricTo,
  check1, check2, loading,
  onMaterialFromChange, onMaterialToChange,
  onFabricFromChange, onFabricToChange,
  onCheck1Change, onCheck2Change, onQuery,
}) => {
  /** BR-FILTER-01: When materialFrom loses focus, auto-fill materialTo. */
  const handleMaterialFromBlur = () => {
    const trimmed = materialFrom.trim();
    if (trimmed && !materialTo) {
      const padded = (trimmed + 'zzzzzz').substring(0, 6);
      onMaterialToChange(padded);
    }
  };

  /** BR-FILTER-02: When fabricFrom loses focus, auto-fill fabricTo. */
  const handleFabricFromBlur = () => {
    const trimmed = fabricFrom.trim();
    if (trimmed && !fabricTo) {
      const padded = (trimmed + '\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff').substring(0, 15);
      onFabricToChange(padded);
    }
  };

  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      {/* Row 1: Material code range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 110 }}>原料代號 [從]</span>
          <Input
            value={materialFrom}
            onChange={(e) => onMaterialFromChange(e.target.value.toUpperCase())}
            onBlur={handleMaterialFromBlur}
            placeholder="起"
            style={{ width: 120 }}
            maxLength={6}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={materialTo}
            onChange={(e) => onMaterialToChange(e.target.value.toUpperCase())}
            placeholder="迄"
            style={{ width: 120 }}
            maxLength={6}
          />
        </div>
      </div>

      {/* Row 2: Factory fabric no range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 110 }}>工廠布號 [從]</span>
          <Input
            value={fabricFrom}
            onChange={(e) => onFabricFromChange(e.target.value)}
            onBlur={handleFabricFromBlur}
            placeholder="起"
            style={{ width: 180 }}
            maxLength={15}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={fabricTo}
            onChange={(e) => onFabricToChange(e.target.value)}
            placeholder="迄"
            style={{ width: 180 }}
            maxLength={15}
          />
        </div>
      </div>

      {/* Row 3: Report selection checkboxes */}
      <div className="flex flex-wrap items-center gap-6 mb-3">
        <span className="text-sm font-medium">印表選擇</span>
        <Checkbox
          checked={check1}
          onChange={(e: CheckboxChangeEvent) => onCheck1Change(e.target.checked)}
        >
          原料代號別
        </Checkbox>
        <Checkbox
          checked={check2}
          onChange={(e: CheckboxChangeEvent) => onCheck2Change(e.target.checked)}
        >
          工廠布號別
        </Checkbox>
      </div>

      {/* Query button */}
      <div className="flex gap-2">
        <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
          查詢
        </Button>
      </div>
    </div>
  );
};

export default QueryParams;
